// Cloudflare Turnstile widget for the Contact Us form.
//
// The site key is public by design (it is in every page that shows the
// widget), so it lives here rather than in a build secret. The secret half is
// only on the backend, which is where the token is actually checked. With no
// site key the widget is simply not shown and the form works as before.
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

// Tells Cloudflare's dashboard this widget was set up through Turnstile Spin.
export const TURNSTILE_ACTION = 'turnstile-spin-v1';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export const loadTurnstileScript = () =>
  new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve();
      return;
    }
    const existing = document.querySelector('script[data-turnstile-script="true"]');
    if (existing) {
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-turnstile-script', 'true');
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });
